import React from 'react';
import {noop} from '../../../utils/Utils';
import Icon from '../../icon/Icon';
import {onEnterOrSpace} from '../../../utils/Accessibility';
import {ListViewItemDecoration} from './ListViewItem.types';

export interface ItemSecondaryButtonProps {
  decoration: ListViewItemDecoration;
  onClick: (event: React.UIEvent) => void;
}

const ListViewItemSecondaryButton: React.FC<ItemSecondaryButtonProps> = ({ decoration, onClick }) => {

  const props = {
    className:   'listview-item__button listview-item__button--secondary',
    'tab-index': 1,
    onClick:     (event: React.MouseEvent) => (onClick ?? noop)(event),
    onKeyPress:  (event: React.KeyboardEvent) => onEnterOrSpace(event, () => (onClick ?? noop)(event))
  };

  return <button {...props}>
    <Icon category={decoration.icon}
          size={decoration.size}
          ariaLabel={decoration.ariaLabel}/>
  </button>;
};

export default ListViewItemSecondaryButton;
